import CommonUtil from '@/common/utils/CommonUtil'
import { FormatConstants } from './../../../common/FormatConstants'
import ApiUrlConstants from '@/common/ApiUrlConstants'
import RestService from '@/common/RestService'
import CABA1010RequestModel from '@/api/data/CAB/CABA1010/CABA1010RequestModel'
import CABA1010ResponseModel from '@/api/data/CAB/CABA1010/CABA1010ResponseModel'
import CABA1011RequestModel from '@/api/data/CAB/CABA1011/CABA1011RequestModel'
import CABA1011ResponseModel from '@/api/data/CAB/CABA1011/CABA1011ResponseModel'
import moment from 'moment'
import ValidateUtil from '@/common/utils/ValidationUtil'

export default class CABG1010Service {
  /**
   * CABA1010 API呼出処理
   * @returns caba1010ResponseModel
   */
  public async callAPICABA1010(): Promise<CABA1010ResponseModel> {
    const caba1010RequestModel = new CABA1010RequestModel()

    const caba1010ResponseModel: CABA1010ResponseModel = <
      CABA1010ResponseModel
    > await RestService.post(ApiUrlConstants.CABA1010, caba1010RequestModel)
    return caba1010ResponseModel
  }

  /**
   * CABA1011 API呼出処理
   * @returns caba1011ResponseModel
   */
  public async callAPICABA1011(): Promise<CABA1011ResponseModel> {
    const caba1011RequestModel = new CABA1011RequestModel()
    const caba1011ResponseModel: CABA1011ResponseModel = <
      CABA1011ResponseModel
    > await RestService.post(ApiUrlConstants.CABA1011, caba1011RequestModel)
    return caba1011ResponseModel
  }

  /**
   * 評価損益の推移エリア情報データフィルタ
   * @param yearNum 1年、3年、5年、10年。
   * @param data「CABA1011」APIから返され
   * @returns dataReturn
   */
  public clickChangeYear(yearNum: number, data: Array<object>): Array<any> {
    let dataReturn = []
    const monthNum = yearNum * 12
    const endIndex = data.length < monthNum ? data.length : monthNum
    dataReturn = data.slice(0, endIndex)

    return dataReturn
  }

  /**
   * チャートのツールチップ表示マッピングデータ作成
   * @param assetBalncTransInfo 「CABA1011」APIから返され
   * @returns dataMapping []
   */
  public createMappingAssetBalncTransInfo(
    assetBalncTransInfo: Array<any>
  ): Array<object> {
    const dataMapping = []
    for (let i = 0; i < assetBalncTransInfo.length; i++) {
      const operatYield = CommonUtil.roundNumber(
        assetBalncTransInfo[i].operatYield,
        FormatConstants.INVEST_WITHOUT_UNIT,
        '--'
      )
      const temp = {
        critYearMon: moment(assetBalncTransInfo[i].critYearMon).format(
          FormatConstants.RETURN_BASE_MONTH
        ),
        pensionAssetEvalPric:
          CommonUtil.roundNumber(
            assetBalncTransInfo[i].pensionAssetEvalPric,
            FormatConstants.RATIO_WITHOUT_UNIT,
            '--'
          ) +
          (ValidateUtil.isNotEmptyValid(
            assetBalncTransInfo[i].pensionAssetEvalPricUnit
          )
            ? assetBalncTransInfo[i].pensionAssetEvalPricUnit
            : '円'),
        operatPric:
          CommonUtil.roundNumber(
            assetBalncTransInfo[i].operatPric,
            FormatConstants.RATIO_WITHOUT_UNIT,
            '--'
          ) +
          (ValidateUtil.isNotEmptyValid(assetBalncTransInfo[i].operatPricUnit)
            ? assetBalncTransInfo[i].operatPricUnit
            : '円'),
        evalPl:
          CommonUtil.roundNumber(
            assetBalncTransInfo[i].evalPl,
            FormatConstants.RATIO_WITHOUT_UNIT,
            '--'
          ) + '',
        evalPlUnit: ValidateUtil.isNotEmptyValid(
          assetBalncTransInfo[i].evalPlUnit
        )
          ? assetBalncTransInfo[i].evalPlUnit
          : '円',
        operatYield:
          (operatYield === '--' ? '--' : operatYield.toFixed(2)) +
          (ValidateUtil.isNotEmptyValid(assetBalncTransInfo[i].operatYieldUnit)
            ? assetBalncTransInfo[i].operatYieldUnit
            : '%')
      }
      dataMapping[assetBalncTransInfo[i].critYearMon] = temp
    }
    return dataMapping
  }
}
